//@ts-ignore
import { QueryEMX2 } from "molgenis-components";
import { IFilterFacet } from "../interfaces/interfaces";

type FilterSourceTestResult = {
  success: boolean;
  message: string;
  count?: number;
};

function resolveEndpoint(
  sourceSchema: string | undefined,
  graphqlEndpoint: string
): string {
  if (!sourceSchema) {
    return graphqlEndpoint || "graphql";
  }

  return `${window.location.protocol}//${window.location.host}/${sourceSchema}`;
}

function getSelection(facet: IFilterFacet): string[] {
  if (facet.component === "OntologyFilter") {
    return [
      facet.filterLabelAttribute || "label",
      facet.filterValueAttribute || "name",
      "code",
      `parent.${facet.filterValueAttribute || "name"}`,
    ];
  }

  const baseSelection = [
    facet.filterLabelAttribute || "name",
    facet.filterValueAttribute || "id",
  ];

  if (facet.extraAttributes?.length) {
    return [...baseSelection, ...facet.extraAttributes];
  }

  return baseSelection;
}

export async function testFilterSource(
  facet: IFilterFacet,
  graphqlEndpoint: string
): Promise<FilterSourceTestResult> {
  if (facet.customOptions?.length) {
    return {
      success: true,
      message: "Filter uses customOptions. No source query needed.",
      count: facet.customOptions.length,
    };
  }

  if (!facet.sourceTable) {
    return {
      success: false,
      message: "sourceTable is required to test source connectivity.",
    };
  }

  try {
    const endpoint = resolveEndpoint(facet.sourceSchema, graphqlEndpoint);
    const selection = getSelection(facet);

    const response = await new QueryEMX2(endpoint)
      .table(facet.sourceTable)
      .select(selection)
      .orderBy(
        facet.sourceTable,
        facet.sortColumn || "name",
        (facet.sortDirection || "asc").toLowerCase()
      )
      .execute();

    const results = response?.[facet.sourceTable] || [];

    return {
      success: true,
      message: `Source query succeeded for '${facet.sourceTable}'.`,
      count: results.length,
    };
  } catch (error: any) {
    return {
      success: false,
      message: `Source query failed: ${error?.message || "unknown error"}`,
    };
  }
}
